import React, { createContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { fetchWithRetry } from "../utils/fetchWithRetry";

export const HomeSliderContext = createContext();

const ASSETS_BASE = process.env.REACT_APP_API_BASE_URL + "/assets/";
const API_URL = process.env.REACT_APP_API_BASE_URL + "/items/home_slider";

const getAssetUrl = (fileOrId) => {
  if (!fileOrId) return null;
  if (typeof fileOrId === "string") return `${ASSETS_BASE}${fileOrId}`;
  if (fileOrId.id) return `${ASSETS_BASE}${fileOrId.id}`;
  return null;
};

export const HomeSliderProvider = ({ children }) => {
  const [slider, setSlider] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const ac = new AbortController();

    const fetchSlider = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetchWithRetry(
          () =>
            axios.get(API_URL, {
              signal: ac.signal,
              params: {
                "filter[status][_eq]": "published",
                sort: "sort",
                limit: 100,
                fields: "*.*"
              },
            }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );

        const items = res?.data?.data ?? [];
        setSlider(items);
      } catch (e) {
        if (!ac.signal.aborted) setError("Fehler beim Laden des Home Sliders.");
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    };

    fetchSlider();
    return () => ac.abort();
  }, []);

  // Готовим массив картинок уже в нужном порядке
  /* const pics = useMemo(() => {
    const arr = slider?.pics ?? [];
    // подстраховка: если deep sort не сработал — сортируем на клиенте
    const sorted = [...arr].sort((a, b) => (a.sort ?? 9999) - (b.sort ?? 9999));
    return sorted
      .map((p) => p?.directus_files_id)
      .filter(Boolean)
      .map((file) => ({
        id: file.id,
        url: getAssetUrl(file),
        alt: file.title || file.description || "Slide",
        file,
      }))
      .filter((x) => x.url);
  }, [slider]); */

  return (
    <HomeSliderContext.Provider value={{ slider, loading, error }}>
      {children}
    </HomeSliderContext.Provider>
  );
};
